import React, { useState, useRef, useEffect } from "react";
import { Check, ChevronsUpDown } from "lucide-react";

export function BillerSearch({ billers, loading, value, onSelect }) {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selectedName = billers.find((b) => b.id === value)?.name || "";
  const filtered = search
    ? billers.filter((b) => b.name.toLowerCase().includes(search.toLowerCase()))
    : billers;

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  if (loading)
    return (
      <div className="h-9 rounded-md border bg-muted flex items-center px-3 text-sm text-muted-foreground">
        Loading billers…
      </div>
    );
  if (billers.length === 0)
    return (
      <div className="h-9 rounded-md border bg-muted flex items-center px-3 text-sm text-muted-foreground">
        No billers available
      </div>
    );

  return (
    <div className="relative" ref={ref}>
      <div
        className="flex h-9 w-full items-center rounded-md border border-input bg-transparent px-3 text-sm cursor-pointer"
        onClick={() => setOpen(true)}
        data-testid="biller-search-trigger"
      >
        {!open && (
          <>
            <span className="truncate flex-1">
              {selectedName || "Search & select biller…"}
            </span>
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </>
        )}
        {open && (
          <input
            autoFocus
            className="flex-1 bg-transparent outline-none placeholder:text-muted-foreground"
            placeholder="Type to search…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            data-testid="biller-search-input"
          />
        )}
      </div>
      {open && (
        <div className="absolute z-[100] mt-1 w-full max-h-48 overflow-y-auto rounded-md border bg-popover shadow-lg">
          {filtered.length === 0 && (
            <div className="p-3 text-sm text-muted-foreground text-center">
              No billers match &ldquo;{search}&rdquo;
            </div>
          )}
          {filtered.map((b) => (
            <div
              key={b.id}
              className={`flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-accent transition-colors ${
                b.id === value ? "bg-accent font-medium" : ""
              }`}
              onClick={() => {
                onSelect(b.id);
                setSearch("");
                setOpen(false);
              }}
              data-testid={`biller-opt-${b.id}`}
            >
              <Check
                className={`h-3.5 w-3.5 shrink-0 ${
                  b.id === value ? "opacity-100 text-primary" : "opacity-0"
                }`}
              />
              {b.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
